// @flow

import { type CheckoutReceipts, type Receipt } from './types';

export function getMainReceipt(receipts: CheckoutReceipts): Receipt {
  return receipts.main;
}
